import { TableCell, TableRow, makeStyles } from '@material-ui/core';
import React, { useRef } from 'react';
import {
  Timeline,
  TimelineConnector,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from '@material-ui/lab';
import { presentFormatedData } from '../../functionalComponents/dataFormatFunctions';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  column1: {
    padding: '0px',
    borderBottom: 'none',
    // '& ul.MuiTimeline-root.MuiTimeline-alignAlternate': {
    //   padding: '0px',
    //   margin: '0px',
    // },
    '& ul.MuiTimeline-root.MuiTimeline-alignLeft': {
      padding: '0px',
      margin: '0px',
    },
  },
  eventDescriptionList: {
    paddingLeft: '0', // Removes default padding for the <ul>
    marginTop:'0px',
    // listStyleType: 'none', // Removes bullets from the list
    textAlign: 'left', // Ensures the list items are left-aligned
    '& li': {
      marginBottom: '10px', // Adds space between list items
    },
  },
}));

const ForecastAuditSingleRow = (props) => {
  const targetHeightRef = useRef();
  // const [dividerHeight, setDividerHeight] = useState();
  const classes = useStyles();
  const { row, listLength, rowNo, selectedFilterData } = props;

  // useEffect(() => {
  //   if (targetHeightRef.current) {
  //     // setDividerHeight(targetHeightRef.current.offsetHeight + 15);
  //     setDividerHeight(targetHeightRef.current.offsetHeight);
  //   }
  // }, [rowNo, targetHeightRef.current]);

  return (
      <TableRow ref={targetHeightRef}>
      <TableCell
        style={{ minWidth: '50px', position: 'relative', overflow: 'hidden' }}
        align='center'
        className={classes.column1}
      >
        <Timeline
        // style={{ height: dividerHeight }}
        >
          <TimelineItem
            // style={{ minHeight: dividerHeight, height: dividerHeight }}
            style={{ height: '100%', position: 'absolute', right: 0, top: 0 }}
          >
            <TimelineSeparator>
              {rowNo !== 0 ? (
                <TimelineConnector style={{flexGrow: Array.isArray(row.eventDescription) && 0,height: Array.isArray(row.eventDescription) &&'20px'}} />
              ) : (
                <TimelineConnector
                  style={{
                    background: 'transparent',
                      // height: dividerHeight / 2,
                      flexGrow: Array.isArray(row.eventDescription) && 0,
                      height: Array.isArray(row.eventDescription) && '20px'
                  }}
                />
              )}
              <TimelineDot
                // variant={rowNo !== 0 ? 'default' : 'outlined'}
                variant='default'
                style={{
                  // background: rowNo !== 0 ? '#EC6535' : 'none',
                  background: '#EC6535',
                  color: '#000',
                }}
              />
              {rowNo !== listLength - 1 ? (
                <TimelineConnector />
              ) : (
                <TimelineConnector
                  style={{
                    background: 'transparent',
                    // height: dividerHeight / 2,
                  }}
                />
              )}
            </TimelineSeparator>
          </TimelineItem>
        </Timeline>
      </TableCell>
      <TableCell align='left' style={{ minWidth: '100px', maxWidth: '120px', width: '100px', alignContent: Array.isArray(row.eventDescription) && 'flex-start'  }}>
        {row.lastUpdatedDate ? `${moment(row.lastUpdatedDate).utcOffset("+05:30").format("DD/MM/YYYY HH:mm:ss")}  (IST)`:' - '}
      </TableCell>
      <TableCell align='left' style={{ alignContent: Array.isArray(row.eventDescription) && 'flex-start'  }}>
        {presentFormatedData(row.eventType, '-NA-')}
      </TableCell>
      <TableCell align='left' style={{width:'250px'}}>
        {!row.eventDescription ? '-NA-' : typeof row.eventDescription === 'string' ?
          presentFormatedData(row.eventDescription, '-NA-') :
          Array.isArray(row.eventDescription)
          && <ul className={classes.eventDescriptionList}>
          {row.eventDescription.map((item, index) => (
            <li key={index}>
              {presentFormatedData(item.eventDescription, '-NA-')}
            </li>
          ))}
        </ul>}
      </TableCell>
      <TableCell align='left' style={{ alignContent: Array.isArray(row.eventDescription) && 'flex-start'  }}>
        {/* {presentFormatedData(row.forecastScheduleID, '-NA-')} */}
        {presentFormatedData(selectedFilterData.forecastScheduleId, '-NA-')}
      </TableCell>
      <TableCell align='left' style={{ alignContent: Array.isArray(row.eventDescription) && 'flex-start'  }}>
        {presentFormatedData(row.status, '-NA-')}
      </TableCell>
      <TableCell align='left' style={{ alignContent: Array.isArray(row.eventDescription) && 'flex-start'  }}>
        {presentFormatedData(row.orgName, '-NA-')}
      </TableCell>
      <TableCell align='left' style={{ alignContent: Array.isArray(row.eventDescription) && 'flex-start'  }}>
        {presentFormatedData(row.role, '-NA-')}
      </TableCell>
      <TableCell align='left' style={{ alignContent: Array.isArray(row.eventDescription) && 'flex-start'  }}>
        {presentFormatedData(row.userName, '-NA-')}
      </TableCell>
    </TableRow>
  );
};

export default ForecastAuditSingleRow;
